module.exports = __webpack_public_path__ + "img/eclipse-cross-red-compressor.8de11f81.png";